import RoundedButton from 'components/RoundedButton';
import BlogArticle from 'components/blog/BlogArticle';
import BlogLink from 'components/blog/BlogLink';
import MainLayout from 'components/layout/MainLayout';
import { NextSeo } from 'next-seo';
import { getCta } from 'utils/common';
import { ASSET_PREFIX } from 'utils/constants';

const Article = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/how-daymade-celebrates-international-womens-day-2023`;

  return (
    <MainLayout additionalClassName="blogPost">
      <NextSeo
        title="International Women’s Day | Win Epic Prizes | DAYMADE"
        description="Today we put some of our female-founded prizes in the spotlight and tell you more about DAYMADE’s initiative to celebrate and support them on International Women’s Day 23."
        openGraph={{
          title: 'International Women’s Day | Win Epic Prizes | DAYMADE',
          description:
            'Today we put some of our female-founded prizes in the spotlight and tell you more about DAYMADE’s initiative to celebrate and support them on International Women’s Day 23.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/how-daymade-celebrates-international-womens-day-2023',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: 'Female business owner',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'women's day,female business',
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="Female business owner"
        heroImageYPosition="58%"
      >
        <>
          <h1 style={{ fontSize: '1.6em', lineHeight: '1.4em' }}>
            How DAYMADE celebrates International Women's Day 23
          </h1>

          <p className="subheading"></p>

          <div className="separator" style={{ width: '80%', marginTop: 0 }} />

          <p
            style={{
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '2em',
            }}
          ></p>

          <p>
            International Women's Day is a global celebration of the social,
            economic, cultural, and political achievements of women. It's also a
            day to advocate for gender equality and to raise awareness of the
            challenges that women face. In recent years, there has been a
            significant rise in female entrepreneurship in the UK, with more and
            more women starting their own businesses. Today is a great day to
            put some of our female-founded prizes in the spotlight and tell you
            more about DAYMADE’s initiative to celebrate and support them on
            International Women's Day 23.
          </p>

          <h2>The Rise of Female Founders in the UK</h2>

          <p>
            According to a report by the Federation of Small Businesses, as of
            2021, 34% of small business owners in the UK are female. This is a
            significant increase from previous years and shows that more women
            are taking the leap into entrepreneurship. There are several reasons
            for this rise in female entrepreneurship, including greater access
            to funding and more support networks for women in business. Fun
            fact: DAYMADE is also partly female founded!
          </p>

          <h2>Female-founded prizes on DAYMADE</h2>

          <p>
            If there was ever a good day to highlight some of our female-founded
            prizes, it’s today!
          </p>

          <p>
            <BlogLink internal="/prizes/details/charlotte-tilbury-gift-card-30">
              A £30 Charlotte Tilbury gift card:
            </BlogLink>{' '}
            Charlotte Tilbury is a luxury makeup and skincare brand founded by
            makeup artist Charlotte Tilbury in 2013. The brand has since become
            a global sensation, with products sold in over 70 countries.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt="charlotte tilby"
            className="singleBlogImage"
          />

          <p>
            <BlogLink internal="/prizes/details/authentic-house-25-gift-card">
              A £25 Authentic House gift card:
            </BlogLink>{' '}
            From a subscription box, then an eco shop, to working with makers to
            create their own range and now formulating refillable skincare,
            Alice has been working non-stop on making the world a more
            sustainable place since 2018. Our players LOVE Authentic House
            products.
          </p>

          <p>
            <BlogLink internal="/prizes/details/indytute-gift-card-30">
              The Indytute £30 gift card:
            </BlogLink>{' '}
            Ever since we launched DAYMADE, our focus has been on experiences
            over money. That’s what makes us different as a lottery-style
            competition! So we were buzzing to find our partner-in-crime Calypso
            Rose, who founded experience platform The Indytute. Calypso: “I feel
            passionately that instead of giving more clutter, which we really
            don't need, we give good times! Ones that don't cost the earth,
            don't take up a huge amount of time but bring a lot of joy and fun
            into our lives (and we all need more of that!).”
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
            alt="Calypso the founder of indytute"
            className="singleBlogImage"
          />

          <p>
            <BlogLink internal="/prizes/details/naturally-legit-lavender-box">
              Naturally Legit hair & body care box:
            </BlogLink>{' '}
            Some of our female-founded prizes are from our very own players! Ema
            Ursan started Naturally Legit during the pandemic and it ended up
            being one of our most popular prizes! Naturally Legit are committed
            to creating natural skincare products and plastic free household
            solutions. All their products are handmade in small batches, are
            cruelty-free, and come packaged in planet-friendly materials.
          </p>

          <h2>DAYMADE’S plan for International Women's Day 23</h2>

          <p>
            As much as International Women’s Day is about celebrating women,
            it’s even more important to take action. In addition to the
            female-founded prizes mentioned above, DAYMADE has added 3 more to
            the mix today: Fably plant pots, Girls Who Grind Coffee subscription
            and Prick LDN succulents and candles.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
            alt="the owners of Girls Who Grind"
            className="singleBlogImage"
          />

          <p>
            We’ll also dedicate our{' '}
            <BlogLink internal="/token-town/pound-raffle">
              Pound Raffle
            </BlogLink>{' '}
            (draw on the 9th of March at 10pm) to women. All the ticket sale
            proceeds will go to a women’s charity as chosen by the winner.
            Options will be Care, Equality Now, Women’s Aid, Women on Waves,
            Girl Guides, ActionAid or UN women. The prize itself will be a
            lovely care bundle which includes prizes of (you guessed it!) female
            founded businesses like FlowerBe, Cutter & Squidge, Lovely Lydia and
            Maegan. Treat yourself or a special woman in your life to a bundle
            full of goodies!
          </p>

          <p>
            You can also enter the Pound Raffle for free via Instagram by
            tagging a woman in your life who you want to give a shout out to and
            tagging @daymadeuk with the hashtag #IWD2023 and the official
            hashtag this year #embraceequity.
          </p>

          <h2>What can you do to celebrate International Women’s Day ‘23?</h2>

          <p>
            On International Women's Day 23, there are many ways you can support
            and celebrate female-founded ecommerce businesses in the UK. Here
            are some ideas:
          </p>

          <p>
            Shop at women-owned businesses: Whether it's buying makeup from
            Charlotte Tilbury, skincare from Naturally Legit or experiences from
            the Indytute, supporting these female-founded businesses can make a
            big difference.
          </p>

          <p>
            Attend virtual events: Many female-founded businesses are hosting
            virtual events on International Women's Day 23, such as panel
            discussions, workshops, and networking events. Attending these
            events can help you learn more about the industry and connect with
            other women in business.
          </p>

          <p>
            Share on social media: Sharing the stories of inspirational women
            and female-founded businesses on social media can help raise
            awareness of their achievements and encourage others to support
            them.
          </p>

          <h2>Female Founders and Success</h2>

          <p>
            Research has shown that female-founded businesses in the UK are
            often more successful than their male counterparts. For example, a
            study by the business software firm Xero found that female-led small
            businesses in the UK grew revenue by an average of 13.8% over the
            past year, compared to 10.4% for male-led small businesses. Another
            study by the investment firm Barclays found that women-owned
            businesses in the UK generated £105 billion in revenue and created
            2.85 million jobs in 2019.
          </p>

          <p>
            Despite these successes, there is still a long way to go when it
            comes to gender equality in the workplace. According to a study by
            the professional services firm PwC, only 7% of FTSE 100 CEOs in the
            UK are female. However the number of female CEOs is slowly
            increasing, with 34% of new appointments in 2020 being women.
          </p>

          <p>
            International Women's Day 23 is a day to celebrate the achievements
            of women around the world and to advocate for gender equality.
            Female-founded ecommerce businesses in the UK are a great example of
            women's success in the business world, and supporting these
            businesses is always a priority for DAYMADE.
          </p>

          <p>
            Let's continue to support and empower women in business, and work
            towards a more gender-equal future. If you have any tips on what
            more DAYMADE can do to support women, you can reach out to us via{' '}
            <a href="mailto:<hello@daymade.co.uk">hello@daymade.co.uk</a>.
          </p>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px', margin: '1em 0 1.5em' }}
          >
            Enter Now
          </RoundedButton>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default Article;
